<app-resources-page-menu
  [size]="'small'"
  [context]="this.context">
</app-resources-page-menu>

<div class="wrapper">
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>